export const columns = [
  // {
  //   title: " 品牌",
  //   dataIndex: "brand",
  //   key: "brand",
  //   type: "string",
  //   noSearch: false,
  //   ellipsis: true,
  // },
  // {
  //   title: "厂家",
  //   dataIndex: "factoryName",
  //   key: "factoryName",
  //   type: "string",
  //   noSearch: false,
  //   ellipsis: true,
  // },
  {
    title: "code",
    dataIndex: "code",
    key: "code",
    type: "string",
    noSearch: false,
    ellipsis: true,
  },
  {
    title: "model",
    dataIndex: "model",
    key: "model",
    type: "string",
    noSearch: false,
    ellipsis: true,
  },
];
